module.exports = __webpack_public_path__ + "img/logo.19cac763.png";